document.querySelectorAll('.sidebar li a').forEach((element) => {
    element.classList.remove('bg-active', 'text-active-text');
});

document.querySelectorAll('.sidebar li:nth-child(5) a').forEach((element) => {
    element.classList.add('bg-active', 'text-active-text');
});
